var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import * as moment from "moment";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
var LiveNewsPresenter = /** @class */ (function () {
    function LiveNewsPresenter(actions, usecase, useCasesStream, useCasesNewsStream) {
        this.actions = actions;
        this.usecase = usecase;
        this.useCasesStream = useCasesStream;
        this.useCasesNewsStream = useCasesNewsStream;
        this.liveNews = {
            content: [],
            number: 0,
            size: 0,
            totalElements: 0,
            totalPages: 0,
        };
        this.symbols = [];
    }
    LiveNewsPresenter.prototype.getLiveNewsData = function (requestData) {
        var _this = this;
        this.actions.hideError();
        this.actions.setStartLiveNewsLoader();
        var newsPayload = {
            segmentType: requestData === null || requestData === void 0 ? void 0 : requestData.segmentType,
            exclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.exclCategory) ? requestData.exclCategory : [],
            validRequest: false,
            inclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.inclCategory)
                ? requestData.inclCategory
                : ["Default"],
            page: requestData === null || requestData === void 0 ? void 0 : requestData.page,
            searchText: requestData === null || requestData === void 0 ? void 0 : requestData.searchText,
        };
        this.usecase.liveNews.execute({
            onSuccess: function (data) {
                if (data.content.length > 0 && (requestData === null || requestData === void 0 ? void 0 : requestData.page) > 0) {
                    _this.liveNews.content = __spreadArray(__spreadArray([], __read(_this.liveNews.content), false), __read(data.content), false);
                    _this.liveNews.number = data.number;
                    _this.liveNews.totalPages = data.totalPages;
                    _this.liveNews.totalElements = data.totalElements;
                    _this.liveNews.size = data.size;
                }
                else
                    _this.liveNews = data;
                data === null || data === void 0 ? void 0 : data.content.map(function (news) {
                    var _a;
                    (_a = news === null || news === void 0 ? void 0 : news.customElements) === null || _a === void 0 ? void 0 : _a.map(function (z) {
                        if ((z === null || z === void 0 ? void 0 : z.sym) !== "" && !_this.symbols.includes(z === null || z === void 0 ? void 0 : z.sym)) {
                            _this.symbols.push(z.sym);
                        }
                    });
                });
                _this.actions.getLiveNewsData(_this.liveNews);
                _this.actions.setStopLiveNewsLoader();
            },
            onError: function (error) {
                _this.actions.setStopLiveNewsLoader();
                _this.actions.setError({ isOpen: true, error: error });
            },
        }, newsPayload);
    };
    LiveNewsPresenter.prototype.getEquityHoldingLiveNews = function (requestData) {
        var _this = this;
        this.actions.hideError();
        this.actions.setStartLiveNewsLoader();
        var newsPayload = {
            exclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.exclCategory) ? requestData.exclCategory : [],
            validRequest: false,
            inclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.inclCategory)
                ? requestData.inclCategory
                : ["Default"],
            page: requestData === null || requestData === void 0 ? void 0 : requestData.page,
            searchText: requestData === null || requestData === void 0 ? void 0 : requestData.searchText,
        };
        this.usecase.equityHoldingLiveNews.execute({
            onSuccess: function (data) {
                if (data.content.length > 0 && requestData.page > 0) {
                    _this.liveNews.content = __spreadArray(__spreadArray([], __read(_this.liveNews.content), false), __read(data.content), false);
                    _this.liveNews.number = data.number;
                    _this.liveNews.totalPages = data.totalPages;
                    _this.liveNews.totalElements = data.totalElements;
                    _this.liveNews.size = data.size;
                }
                else
                    _this.liveNews = data;
                data.content.map(function (news) {
                    var _a;
                    (_a = news.customElements) === null || _a === void 0 ? void 0 : _a.map(function (z) {
                        if (z.sym !== "" && !_this.symbols.includes(z.sym))
                            _this.symbols.push(z.sym);
                    });
                });
                _this.actions.getLiveNewsData(_this.liveNews);
                _this.actions.getEquityHoldingLiveNews(_this.liveNews);
                _this.actions.setStopLiveNewsLoader();
            },
            onError: function (error) {
                _this.actions.setStopLiveNewsLoader();
                _this.actions.setError({ isOpen: true, error: error });
            },
        }, newsPayload);
    };
    LiveNewsPresenter.prototype.getNewsQouteStreamData1 = function (subscribe, symbols, sectionName) {
        var _this = this;
        var streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
        ];
        if (symbols.length > 0)
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (symbols.includes(mappedData.symbol)) {
                        this.actions.getNewsStreamData(mappedData);
                    }
                    return [2 /*return*/];
                });
            }); }, symbols, streamMapKey, StreamingSectionName.NEW_STREAMING);
    };
    LiveNewsPresenter.prototype.getNewsQouteStreamData = function (subscribe) {
        var _this = this;
        var symb = this.symbols;
        var streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
        ];
        if (symb.length > 0)
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (symb.includes(mappedData.symbol)) {
                        this.actions.getNewsStreamData(mappedData);
                    }
                    return [2 /*return*/];
                });
            }); }, symb, streamMapKey, StreamingSectionName.NEW_STREAMING);
    };
    LiveNewsPresenter.prototype.getLiveNewsStreaming = function (subscribe) {
        var _this = this;
        this.useCasesStream.streamQuote(STREAMING_TYPE.NEWS, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if (mappedData.hasOwnProperty("customElements") &&
                    ((_a = mappedData === null || mappedData === void 0 ? void 0 : mappedData.customElements) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    !this.symbols.includes(mappedData.customElements[0].sym)) {
                    this.symbols.push(mappedData.customElements[0].sym);
                }
                mappedData.timeText = moment(mappedData.timeText).fromNow();
                this.actions.getLiveNewsStreamData(mappedData);
                return [2 /*return*/];
            });
        }); }, [], [], StreamingSectionName.NEWS);
    };
    LiveNewsPresenter.prototype.resetCount = function () {
        this.actions.resetCount();
    };
    return LiveNewsPresenter;
}());
export default LiveNewsPresenter;
